/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 改标列表 的 **请求配置**
 *
 * @分类 旧接口文档/质检改标
 * @请求头 `POST /erp/GaiBiao/getGbInputRecordList`
 */
const postGetGbInputRecordListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/GaiBiao/getGbInputRecordList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetGbInputRecordList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 改标列表 的 **请求函数**
 *
 * @分类 旧接口文档/质检改标
 * @请求头 `POST /erp/GaiBiao/getGbInputRecordList`
 */
export const postGetGbInputRecordList = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetGbInputRecordListRequestConfig, requestData),
    ...args
  );
};
postGetGbInputRecordList.requestConfig = postGetGbInputRecordListRequestConfig;
/**
 * 接口 获取改标录入-商品类型枚举 的 **请求配置**
 *
 * @分类 旧接口文档/质检改标
 * @请求头 `POST /erp/GaiBiao/getGaiBiaoGoodsTypeEnum`
 */
const postGetGaiBiaoGoodsTypeEnumRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/GaiBiao/getGaiBiaoGoodsTypeEnum",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetGaiBiaoGoodsTypeEnum",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取改标录入-商品类型枚举 的 **请求函数**
 *
 * @分类 旧接口文档/质检改标
 * @请求头 `POST /erp/GaiBiao/getGaiBiaoGoodsTypeEnum`
 */
export const postGetGaiBiaoGoodsTypeEnum = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetGaiBiaoGoodsTypeEnumRequestConfig, requestData),
    ...args
  );
};
postGetGaiBiaoGoodsTypeEnum.requestConfig =
  postGetGaiBiaoGoodsTypeEnumRequestConfig;
const mockUrl_0_0_0_1 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_1 = "";
const prodUrl_0_0_0_1 = "";
const dataKey_0_0_0_1 = "data";
/**
 * 接口 修改标数量 的 **请求配置**
 *
 * @分类 旧接口文档/改标用户配置
 * @请求头 `POST /erp/GaiBiao/updateLabelNum`
 */
const postUpdateLabelNumRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/GaiBiao/updateLabelNum",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postUpdateLabelNum",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 修改标数量 的 **请求函数**
 *
 * @分类 旧接口文档/改标用户配置
 * @请求头 `POST /erp/GaiBiao/updateLabelNum`
 */
export const postUpdateLabelNum = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postUpdateLabelNumRequestConfig, requestData),
    ...args
  );
};
postUpdateLabelNum.requestConfig = postUpdateLabelNumRequestConfig;
/**
 * 接口 导入批量修改 的 **请求配置**
 *
 * @分类 旧接口文档/改标用户配置
 * @请求头 `POST /erp/GaiBiao/importToUpdate`
 */
const postImportToUpdateRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/GaiBiao/importToUpdate",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postImportToUpdate",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导入批量修改 的 **请求函数**
 *
 * @分类 旧接口文档/改标用户配置
 * @请求头 `POST /erp/GaiBiao/importToUpdate`
 */
export const postImportToUpdate = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postImportToUpdateRequestConfig, requestData),
    ...args
  );
};
postImportToUpdate.requestConfig = postImportToUpdateRequestConfig;
/**
 * 接口 改标列表-删除改标记录 的 **请求配置**
 *
 * @分类 旧接口文档/改标用户配置
 * @请求头 `POST /erp/GaiBiao/delGbInputRecord`
 */
const postDelGbInputRecordRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/GaiBiao/delGbInputRecord",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postDelGbInputRecord",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 改标列表-删除改标记录 的 **请求函数**
 *
 * @分类 旧接口文档/改标用户配置
 * @请求头 `POST /erp/GaiBiao/delGbInputRecord`
 */
export const postDelGbInputRecord = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postDelGbInputRecordRequestConfig, requestData),
    ...args
  );
};
postDelGbInputRecord.requestConfig = postDelGbInputRecordRequestConfig;
/**
 * 接口 改标列表-改标类型修改 的 **请求配置**
 *
 * @分类 旧接口文档/改标用户配置
 * @请求头 `POST /erp/GaiBiao/updateGbType`
 */
const postUpdateGbTypeRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/GaiBiao/updateGbType",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postUpdateGbType",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 改标列表-改标类型修改 的 **请求函数**
 *
 * @分类 旧接口文档/改标用户配置
 * @请求头 `POST /erp/GaiBiao/updateGbType`
 */
export const postUpdateGbType = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postUpdateGbTypeRequestConfig, requestData), ...args);
};
postUpdateGbType.requestConfig = postUpdateGbTypeRequestConfig;
/**
 * 接口 查看日志 的 **请求配置**
 *
 * @分类 旧接口文档/改标用户配置
 * @请求头 `POST /erp/GaiBiao/labelNumLog`
 */
const postLabelNumLogRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/GaiBiao/labelNumLog",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postLabelNumLog",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 查看日志 的 **请求函数**
 *
 * @分类 旧接口文档/改标用户配置
 * @请求头 `POST /erp/GaiBiao/labelNumLog`
 */
export const postLabelNumLog = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postLabelNumLogRequestConfig, requestData), ...args);
};
postLabelNumLog.requestConfig = postLabelNumLogRequestConfig;
/**
 * 接口 标入库 的 **请求配置**
 *
 * @分类 旧接口文档/改标用户配置
 * @请求头 `POST /erp/GaiBiao/labelStockIn`
 */
const postLabelStockInRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/GaiBiao/labelStockIn",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postLabelStockIn",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 标入库 的 **请求函数**
 *
 * @分类 旧接口文档/改标用户配置
 * @请求头 `POST /erp/GaiBiao/labelStockIn`
 */
export const postLabelStockIn = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postLabelStockInRequestConfig, requestData), ...args);
};
postLabelStockIn.requestConfig = postLabelStockInRequestConfig;
/**
 * 接口 标库存列表 的 **请求配置**
 *
 * @分类 旧接口文档/改标用户配置
 * @请求头 `POST /erp/GaiBiao/leadingLabelList`
 */
const postLeadingLabelListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/GaiBiao/leadingLabelList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postLeadingLabelList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 标库存列表 的 **请求函数**
 *
 * @分类 旧接口文档/改标用户配置
 * @请求头 `POST /erp/GaiBiao/leadingLabelList`
 */
export const postLeadingLabelList = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postLeadingLabelListRequestConfig, requestData),
    ...args
  );
};
postLeadingLabelList.requestConfig = postLeadingLabelListRequestConfig;
/**
 * 接口 调拨至预警库存 的 **请求配置**
 *
 * @分类 旧接口文档/改标用户配置
 * @请求头 `POST /erp/GaiBiao/addEarlyWarningInventory`
 */
const postAddEarlyWarningInventoryRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/GaiBiao/addEarlyWarningInventory",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postAddEarlyWarningInventory",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 调拨至预警库存 的 **请求函数**
 *
 * @分类 旧接口文档/改标用户配置
 * @请求头 `POST /erp/GaiBiao/addEarlyWarningInventory`
 */
export const postAddEarlyWarningInventory = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postAddEarlyWarningInventoryRequestConfig, requestData),
    ...args
  );
};
postAddEarlyWarningInventory.requestConfig =
  postAddEarlyWarningInventoryRequestConfig;
/**
 * 接口 取出预警库存 的 **请求配置**
 *
 * @分类 旧接口文档/改标用户配置
 * @请求头 `POST /erp/GaiBiao/earlyWarningInventoryWithdrawal`
 */
const postEarlyWarningInventoryWithdrawalRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/GaiBiao/earlyWarningInventoryWithdrawal",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postEarlyWarningInventoryWithdrawal",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 取出预警库存 的 **请求函数**
 *
 * @分类 旧接口文档/改标用户配置
 * @请求头 `POST /erp/GaiBiao/earlyWarningInventoryWithdrawal`
 */
export const postEarlyWarningInventoryWithdrawal = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postEarlyWarningInventoryWithdrawalRequestConfig, requestData),
    ...args
  );
};
postEarlyWarningInventoryWithdrawal.requestConfig =
  postEarlyWarningInventoryWithdrawalRequestConfig;
/**
 * 接口 修正库存 的 **请求配置**
 *
 * @分类 旧接口文档/改标用户配置
 * @请求头 `POST /erp/GaiBiao/modifiedInventory`
 */
const postModifiedInventoryRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/GaiBiao/modifiedInventory",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postModifiedInventory",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 修正库存 的 **请求函数**
 *
 * @分类 旧接口文档/改标用户配置
 * @请求头 `POST /erp/GaiBiao/modifiedInventory`
 */
export const postModifiedInventory = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postModifiedInventoryRequestConfig, requestData),
    ...args
  );
};
postModifiedInventory.requestConfig = postModifiedInventoryRequestConfig;
/**
 * 接口 编辑工单ID 的 **请求配置**
 *
 * @分类 旧接口文档/改标用户配置
 * @请求头 `POST /erp/GaiBiao/submitWorkOrder`
 */
const postSubmitWorkOrderRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/GaiBiao/submitWorkOrder",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSubmitWorkOrder",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 编辑工单ID 的 **请求函数**
 *
 * @分类 旧接口文档/改标用户配置
 * @请求头 `POST /erp/GaiBiao/submitWorkOrder`
 */
export const postSubmitWorkOrder = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postSubmitWorkOrderRequestConfig, requestData),
    ...args
  );
};
postSubmitWorkOrder.requestConfig = postSubmitWorkOrderRequestConfig;
const mockUrl_0_0_0_2 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_2 = "";
const prodUrl_0_0_0_2 = "";
const dataKey_0_0_0_2 = "data";
/**
 * 接口 改标录入列表-查看操作日志 的 **请求配置**
 *
 * @分类 仓储API/改标
 * @请求头 `POST /erp/GaiBiao/logs`
 */
const postLogsRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/GaiBiao/logs",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postLogs",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 改标录入列表-查看操作日志 的 **请求函数**
 *
 * @分类 仓储API/改标
 * @请求头 `POST /erp/GaiBiao/logs`
 */
export const postLogs = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postLogsRequestConfig, requestData), ...args);
};
postLogs.requestConfig = postLogsRequestConfig;
const mockUrl_0_0_0_3 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_3 = "";
const prodUrl_0_0_0_3 = "";
const dataKey_0_0_0_3 = "data";
/**
 * 接口 创建供应商仓位 的 **请求配置**
 *
 * @分类 仓储API/仓位
 * @请求头 `POST /erp/GaiBiao/createSupplySpace`
 */
const postCreateSupplySpaceRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_3,
  devUrl: devUrl_0_0_0_3,
  prodUrl: prodUrl_0_0_0_3,
  path: "/erp/GaiBiao/createSupplySpace",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postCreateSupplySpace",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 创建供应商仓位 的 **请求函数**
 *
 * @分类 仓储API/仓位
 * @请求头 `POST /erp/GaiBiao/createSupplySpace`
 */
export const postCreateSupplySpace = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postCreateSupplySpaceRequestConfig, requestData),
    ...args
  );
};
postCreateSupplySpace.requestConfig = postCreateSupplySpaceRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/GaiBiao.js